(function () {
  var boxes = document.querySelectorAll('[data-lm-referral-box]');
  if (!boxes.length) return;

  var rewardTypeLabels = {
    referee_signup: '친구 가입 혜택',
    referee_first_purchase: '친구 첫 구매 혜택',
    referrer_referral_reward: '나의 추천 보상'
  };

  var statusLabels = {
    pending: '지급 예정',
    processing: '처리 중',
    paid: '지급 완료',
    failed: '지급 실패',
    reversed_needed: '확인 필요',
    void: '지급 제외'
  };

  var referrerRewardType = 'referrer_referral_reward';

  function formatNumber(value) {
    if (value === null || value === undefined || value === '') return '-';

    var number = Number(value);
    if (Number.isNaN(number)) return '-';

    return number.toLocaleString('ko-KR');
  }

  function formatAmount(value) {
    return formatNumber(value);
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function setLoading(box, isLoading) {
    var loading = box.querySelector('[data-lm-referral-loading]');
    var content = box.querySelector('[data-lm-referral-content]');
    var dashboard = box.querySelector('[data-lm-referral-dashboard]');

    if (loading) loading.hidden = !isLoading;
    if (content) content.hidden = isLoading;
    if (dashboard) dashboard.hidden = isLoading;
  }

  function showError(box) {
    var loading = box.querySelector('[data-lm-referral-loading]');
    var content = box.querySelector('[data-lm-referral-content]');
    var dashboard = box.querySelector('[data-lm-referral-dashboard]');
    var error = box.querySelector('[data-lm-referral-error]');

    if (loading) loading.hidden = true;
    if (content) content.hidden = true;
    if (dashboard) dashboard.hidden = true;
    if (error) error.hidden = false;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatDate(value) {
    if (!value) return '';

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);

    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  }

  function getRewardTypeLabel(type) {
    return rewardTypeLabels[type] || type || '보상';
  }

  function getStatusLabel(status) {
    return statusLabels[status] || status || '-';
  }

  function getRewardType(item) {
    return item.reward_type || item.rewardType;
  }

  function getRewardStatus(item) {
    return item.status || '';
  }

  function getRewardAmount(item) {
    var amount = Number(item.amount || item.expectedRewardAmount || 0);
    return Number.isNaN(amount) ? 0 : amount;
  }

  function getMyReferralRewardItems(rewards) {
    var items = rewards && Array.isArray(rewards.items) ? rewards.items : [];

    return items.filter(function (item) {
      return getRewardType(item) === referrerRewardType;
    });
  }

  function getPendingReferralOrderItems(rewards) {
    var orders = rewards && Array.isArray(rewards.pendingReferralOrders)
      ? rewards.pendingReferralOrders
      : [];

    return orders.map(function (order) {
      return {
        pendingReferralOrder: true,
        reward_type: referrerRewardType,
        amount: order.expectedRewardAmount,
        status: 'pending',
        rewardDueAt: order.rewardDueAt,
        orderName: order.orderName,
        createdAt: order.rewardDueAt
      };
    });
  }

  function renderRewards(box, rewards) {
    var container = box.querySelector('[data-lm-referral-rewards]');
    if (!container) return;

    var items = getPendingReferralOrderItems(rewards).concat(getMyReferralRewardItems(rewards));

    if (!items.length) {
      container.innerHTML = (
        '<div class="lm-referral-history__empty">' +
          '<strong>아직 추천인 보상 내역이 없습니다.</strong>' +
          '<p>친구가 추천 링크로 가입하고 첫 구매를 완료하면, 14일 확인 후 추천인 보상이 지급됩니다.</p>' +
        '</div>'
      );
      return;
    }

    container.innerHTML = items.map(function (item) {
      var type = escapeHtml(getRewardTypeLabel(getRewardType(item)));
      var status = escapeHtml(getStatusLabel(getRewardStatus(item)));
      var amount = escapeHtml(formatAmount(getRewardAmount(item)));
      var paidAt = item.paid_at || item.paidAt;
      var rewardDueAt = item.reward_due_at || item.rewardDueAt;
      var createdAt = item.created_at || item.createdAt;
      var dateLabel = item.pendingReferralOrder ? '예정일' : (paidAt ? '지급일' : '생성일');
      var dateValue = escapeHtml(formatDate(item.pendingReferralOrder ? rewardDueAt : (paidAt || createdAt)));
      var meta = item.pendingReferralOrder ? '14일 확인 후 지급 예정' : dateLabel + ' ' + dateValue;

      if (item.pendingReferralOrder && dateValue) {
        meta += ' · ' + dateLabel + ' ' + dateValue;
      }

      return (
        '<div class="lm-referral-history__item">' +
          '<div>' +
            '<div class="lm-referral-history__type">' + type + '</div>' +
            '<div class="lm-referral-history__meta">' + escapeHtml(meta) + '</div>' +
          '</div>' +
          '<div class="lm-referral-history__amount-wrap">' +
            '<div class="lm-referral-history__amount">' + amount + '원</div>' +
          '</div>' +
          '<div class="lm-referral-history__status">' + status + '</div>' +
        '</div>'
      );
    }).join('');
  }

  function copyReferralLink(input, message) {
    if (!input || !input.value) return Promise.resolve(false);

    var copied = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(input.value)
      : new Promise(function (resolve) {
        input.select();
        document.execCommand('copy');
        input.blur();
        resolve();
      });

    return copied.then(function () {
      if (message) message.textContent = '추천 링크가 복사되었습니다.';
      return true;
    }).catch(function () {
      input.select();
      if (message) message.textContent = '복사에 실패했습니다. 링크를 직접 복사해 주세요.';
      return false;
    });
  }

  function bindCopyAndShare(box) {
    var copyButton = box.querySelector('[data-lm-copy-referral]');
    var shareButton = box.querySelector('[data-lm-share-referral]');
    var input = box.querySelector('[data-lm-referral-link]');
    var message = box.querySelector('[data-lm-copy-message]');

    if (copyButton && input) {
      copyButton.addEventListener('click', function () {
        copyReferralLink(input, message);
      });
    }

    if (shareButton && input) {
      shareButton.addEventListener('click', function () {
        if (!input.value) return;

        if (navigator.share) {
          navigator.share({
            title: '르멘 친구 초대',
            text: '르멘 추천 링크로 가입하고 크레딧 혜택을 받아보세요.',
            url: input.value
          }).then(function () {
            if (message) message.textContent = '공유창을 열었습니다.';
          }).catch(function () {
            copyReferralLink(input, message);
          });

          return;
        }

        copyReferralLink(input, message);
      });
    }
  }

  function renderDashboard(box, data) {
    var linkInput = box.querySelector('[data-lm-referral-link]');
    var pendingNote = box.querySelector('[data-lm-referral-pending-note]');
    var stats = data.stats || {};
    var rewards = data.rewards || {};
    var pendingAmount = Number(rewards.pendingAmount || 0);

    setText(box, '[data-lm-referral-code]', data.referralCode || '-');
    if (linkInput) linkInput.value = data.referralLink || '';

    setText(box, '[data-lm-referral-stat="registrations"]', formatNumber(stats.registrations));
    setText(box, '[data-lm-referral-stat="purchases"]', formatNumber(stats.purchases));

    setText(box, '[data-lm-referral-reward="pendingAmount"]', formatAmount(rewards.pendingAmount));
    setText(box, '[data-lm-referral-reward="paidAmount"]', formatAmount(rewards.paidAmount));
    setText(box, '[data-lm-referral-reward="reversedNeededAmount"]', formatAmount(rewards.reversedNeededAmount));

    if (pendingNote) pendingNote.hidden = pendingAmount <= 0;

    renderRewards(box, rewards);
    setLoading(box, false);
  }

  boxes.forEach(function (box) {
    if (box.dataset.customerLoggedIn !== 'true') return;

    bindCopyAndShare(box);
    setLoading(box, true);

    fetch('/apps/lmen-referral/me', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok || !body.ok) {
            throw new Error(body.error || 'Referral dashboard request failed.');
          }

          return body;
        });
      })
      .then(function (data) {
        renderDashboard(box, data);
      })
      .catch(function () {
        showError(box);
      });
  });
})();
